import PropTypes from 'prop-types';

import {AppFlags} from '../app/app-types';
import {OELicensingEdition} from '../react-oe/oe-types';
import {OEContextMenuContentType, OEStartViewTypes, OEFreePremiumViewTypes, OECutControllerStyle, OEMainMenuControlBarEntryTypes} from '../lib/oe-types';
import {OEHelpViewConfigFactory} from './views/help-view/oe-help-view-model';
import {OEManualViewConfigFactory} from './views/manual-view/oe-manual-view-model';
import {OETargetMenuDefs} from './elements/target-menu/oe-target-menu-defs';
import {OEMediaCenterAutoplayMode, OEMediaCenterConfigFactory} from './controller/media-center/oe-media-center-model';
import {OEBottomWidgetToolbarLayoutType, OEBottomWidgetToolbarConfigFactory} from './bars/bottom/oe-bottom-widget-toolbar-model';
import {OERightTopBarConfigFactory} from './bars/right-top/oe-right-top-bar-model';
import {OEMainMenuBtnConfigFactory} from './bars/main-menu/oe-main-menu-model';
import {OEFNStartSelectionPropTypes} from './views/flow-nav/start-selection/oe-fn-start-selection-model';
import {OECapBarConfigFactory} from './bars/cap/oe-cap-bar-model';
import {OEScreenshotControllerConfigFactory} from './controller/screenshot/oe-screenshot-controller-model';
import {OESettingsControllerConfigFactory} from './controller/settings/oe-settings-model';
import {OEWelcomeViewConfigFactory} from './views/welcome-view/oe-welcome-view-model';
import {OEInfoMessageViewConfigFactory} from './views/info-message-view/oe-info-message-model';

export const OEDefaultConfigFactory = {};
    
OEDefaultConfigFactory.mainMenu = function()  {
    return {
        showInitially:              false,
        hovering:                   false,
    };
};

OEDefaultConfigFactory.mainMenuControlBar = function()  {
    return {
        enabled:                    true,
        entries: [
            {
                type:               OEMainMenuControlBarEntryTypes.mainMenuControlButton
            }
        ]
    };
};

OEDefaultConfigFactory.contextMenu = function() {
    return {
        content: {
            type:                   OEContextMenuContentType.none,
            showReferences:         false
        }
    };
};

OEDefaultConfigFactory.targetMenu = function()  {
    return {
        enabled:                    true,
        entries:                    OETargetMenuDefs.all
    };
};

OEDefaultConfigFactory.startView = function()  {
    return {
        type:                       OEStartViewTypes.std,
        logo:                       null,
        showAtStartUp:              true,
        targetViewShowedAtStartFlag: false,
        videoContent:               'NnqI0x9lr6M'
    };
};

OEDefaultConfigFactory.startViewDecl = PropTypes.shape({
    type:                           PropTypes.string,
    logo:                           PropTypes.string,
    showAtStartUp:                  PropTypes.bool,
    targetViewShowedAtStartFlag:    PropTypes.bool,
    videoContent:                   PropTypes.string
});

OEDefaultConfigFactory.startSelection = function()  {
    return {
        showLogo:                   true,
        currentItemLabel:           false,
        categoryLabel:              false
    };
};

OEDefaultConfigFactory.startSelectionDecl = PropTypes.shape({
    showLogo:                       PropTypes.bool,
    content:                        OEFNStartSelectionPropTypes.content,
    currentItemLabel:               PropTypes.bool,
    categoryLabel:                  PropTypes.bool,
    licensingAccess:                PropTypes.func,
    moduleLicensingAccess:          PropTypes.func,
    itemLicensingAccess:            PropTypes.func
});

OEDefaultConfigFactory.freePremiumView = function()  {
    return {
        type:                       OEFreePremiumViewTypes.none,
        logo:                       null
    };
};

OEDefaultConfigFactory.freePremiumViewDecl = PropTypes.shape({
    type:                           PropTypes.string,
    logo:                           PropTypes.string
});

OEDefaultConfigFactory.componentController = function(params)  {
    return Object.assign({
        enabled:                    true,
        searchBar:                  true,
        showHelpBtn:                true,
        colorBtnEnabled:            true,
        colorPurityControl:         true,
        catSwitchBtnEnabled:        true,
        catActivationBtnEnabled:    true
    }, params);
};

OEDefaultConfigFactory.labelController = function()  {
    return {
        enabled:                    true,
        showHelpBtn:                true
    };
};

OEDefaultConfigFactory.cutController = function()  {
    return {
        enabled:                    true,
        showHelp:                   true,
        showHelpBtn:                true,
        style:                      OECutControllerStyle.std,
        touchShiftAvailable:        AppFlags.hasOr([AppFlags.import, AppFlags.cutTouchShift]),
        enableTouchShift:           false,
        featureAccess: {
            [OELicensingEdition.basic]: OECutControllerStyle.minimal
        }
    };
};

OEDefaultConfigFactory.substructureController = function()  {
    return {
        enabled:                    true,
        showHelpBtn:                true
    };
};

OEDefaultConfigFactory.searchController = function()  {
    return {
        enabled:                    true,
        showHelpBtn:                true
    };
};

OEDefaultConfigFactory.presentationController = function()  {
    return {
        enabled:                    true,
        showHelpBtn:                true
    };
};

OEDefaultConfigFactory.noteController = function()  {
    return {
        enabled:                    true,
        showHelpBtn:                true,
        noToolbar:                  false
    };
};

OEDefaultConfigFactory.arrowController = function()  {
    return {
        enabled:                    true,
        showHelpBtn:                true
    };
};

OEDefaultConfigFactory.userObjectController = function()  {
    return {
        enabled:                    true,
        showHelpBtn:                true
    };
};

OEDefaultConfigFactory.screenshotController = function()  {
    return OEScreenshotControllerConfigFactory.buildStdConfig();
};

OEDefaultConfigFactory.textViewController = function(adapter)  {
    return {
        enabled:                    !!adapter,
        adapter:                    adapter
    };
};

OEDefaultConfigFactory.bottomWidgetToolbar = function(type, props, allowedLayoutTypes = OEBottomWidgetToolbarLayoutType.all) {
    return (new OEBottomWidgetToolbarConfigFactory).setSingleType(type, props).setAllowedLayoutTypes(allowedLayoutTypes).build();
};

OEDefaultConfigFactory.combineShowHelpState = function(config, showHelp = true, links, link)  {
    if(links && link && !links.find(e => e.link === link))   showHelp = false;
    return (showHelp || !config) ? config : Object.assign({}, config, {showHelpBtn: showHelp && config.showHelpBtn, showHelp: showHelp && config.showHelp});
};

OEDefaultConfigFactory.mediaCenter = function(bigPlayBtnStyle, autoplay = OEMediaCenterAutoplayMode.none)  {
    return OEMediaCenterConfigFactory.std(bigPlayBtnStyle, autoplay);
};

OEDefaultConfigFactory.widget = function()  {
    return {
        showHelp:                   true,
        labelController:            this.labelController(),
        cutController:              this.cutController(),
        settingsController:         OESettingsControllerConfigFactory.buildStdConfig(),
        substructureController:     this.substructureController(),
        searchController:           this.searchController(),
        presentationController:     this.presentationController(),
        noteController:             this.noteController(),
        arrowController:            this.arrowController(),
        userObjectController:       this.userObjectController(),
        bottomWidgetToolbar:        this.bottomWidgetToolbar(),
        componentController:        this.componentController(),
        screenshotController:       this.screenshotController(),
        textViewController:         this.textViewController(),
        secondarySettingsController:    OESettingsControllerConfigFactory.buildSecondaryStdConfig()
    };
};

OEDefaultConfigFactory.infoView = function()  {
    return {
        logo:                       null,
        header:                     true,
        tutorials:                  true,
        mediaContent:               null
    };
};

OEDefaultConfigFactory.uiLayer = function() {
    return {
        capBar:                     OECapBarConfigFactory.buildStdConfig(),
        mainMenuButtons:            OEMainMenuBtnConfigFactory.buildStdButtons(),
        mainMenuConfig:             this.mainMenu(),
        mainMenuControlBar:         this.mainMenuControlBar(),
        contextMenu:                this.contextMenu(),
        widgetConfig:               this.widget(),
        startView:                  this.startView(),
        startSelection:             this.startSelection(),
        welcomeView:                OEWelcomeViewConfigFactory.buildStdConfig(),
        freePremiumView:            this.freePremiumView(),
        infoView:                   this.infoView(),
        helpView:                   OEHelpViewConfigFactory.buildStdConfig(),
        manualView:                 OEManualViewConfigFactory.buildStdConfig(),
        infoMessageView:            OEInfoMessageViewConfigFactory.buildStdConfig(),
        hasMediaCenter:             true,
        targetMenu:                 this.targetMenu(),
        mediaCenter:                this.mediaCenter(),
        rightTopBar:                OERightTopBarConfigFactory.buildStdConfig(),
        disableTutor:               false,
        logo:                       null
    };
};